document.addEventListener('DOMContentLoaded', function () {
  const stickyATC = document.querySelector('#sticky-atc');
  const stickyBtn = document.querySelector('#sticky-atc-btn');
  const mainATC = document.querySelector('form[action*="/cart/add"] [type="submit"]');
  const footer = document.querySelector('footer.section-wrapper') || document.querySelector('footer');

  if (!stickyATC || !stickyBtn || !mainATC) return;

  function checkScroll() {
    const rect = mainATC.getBoundingClientRect();
    const mainAtcOutOfView = rect.bottom < 60 || rect.top > window.innerHeight;

    // Only show once the footer has scrolled into view (i.e. user reached the bottom of the page)
    let nearFooter = false;
    if (footer) {
      const footerRect = footer.getBoundingClientRect();
      nearFooter = footerRect.top < window.innerHeight;
    } else {
      // Fallback: within 200px of the bottom of the document
      nearFooter = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 200;
    }

    if (mainAtcOutOfView && nearFooter) {
      stickyATC.classList.add('show');
    } else {
      stickyATC.classList.remove('show');
    }
  }

  window.addEventListener('scroll', checkScroll);
  window.addEventListener('resize', checkScroll);
  checkScroll();

  stickyBtn.addEventListener('click', () => {
    mainATC.click();
  });
});
